var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',_vm._l((_vm.sortedItems),function(group){return _c('navigation-group',{key:group.code,attrs:{"nav-group":group,"expand":group.code == 'mainNavigationPageGrouping'}})}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }